import React, { useState } from 'react'
import { useLocation } from 'react-router'
import { checkIsActive, KTSVG } from '../../../helpers'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
  disabled?: boolean
  children?: React.ReactNode
}

const AsideMenuItemWithSub: React.FC<Props> = ({
  children, to, title, icon, hasBullet, disabled,
}) => {
  const { pathname } = useLocation()
  const isActive = checkIsActive(pathname, to)
  const [open, setOpen] = useState(isActive)

  return (
    <div className={`amis-item${open ? ' amis-item--open' : ''}${disabled ? ' amis-item--disabled' : ''}`}>
      <div
        className={`ami-link amis-trigger${isActive ? ' ami-link--active' : ''}`}
        onClick={() => !disabled && setOpen((p) => !p)}
        style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
      >
        {hasBullet && <span className='ami-bullet' />}
        {icon && (
          <span className='ami-icon'>
            <KTSVG path={icon} className='svg-icon-4' />
          </span>
        )}
        <span className='ami-title'>{title}</span>
        <span className={`amis-arrow${open ? ' amis-arrow--open' : ''}`}>
          <svg width='10' height='10' viewBox='0 0 10 10' fill='none'>
            <path d='M2.5 3.5L5 6.5L7.5 3.5' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
          </svg>
        </span>
      </div>

      <div className={`amis-sub${open ? ' amis-sub--open' : ''}`}>
        {children}
      </div>
    </div>
  )
}

export { AsideMenuItemWithSub }